import { render, staticRenderFns } from "./ShowStats.vue?vue&type=template&id=1f8f70b9"
import script from "./ShowStats.vue?vue&type=script&lang=js"
export * from "./ShowStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports